import React from 'react';
import { ExtensionIcon } from '../components/ExtensionIcon';
import { colors, typography, spacing, radius, cardStyle } from '../theme';
export const ProductCard = ({ product }) => {
    const [hovered, setHovered] = React.useState(false);
    return (React.createElement("div", { style: {
            ...cardStyle,
            display: 'flex',
            flexDirection: 'column',
            gap: spacing.md,
            transition: 'box-shadow 0.2s, transform 0.2s',
            boxShadow: hovered
                ? `0 8px 24px ${colors.primary}22`
                : '0 1px 3px rgba(0,0,0,0.08)',
            transform: hovered ? 'translateY(-2px)' : 'none',
            cursor: 'default',
            flex: '1 1 300px',
            minWidth: 280,
            maxWidth: 360,
        }, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false) },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: spacing.md } },
            React.createElement(ExtensionIcon, { extId: product.id, abbr: product.abbr, size: 52 }),
            React.createElement("div", null,
                React.createElement("div", { style: {
                        fontSize: typography.fontSizeBase,
                        fontWeight: 700,
                        fontFamily: typography.fontFamily,
                        color: colors.textPrimary,
                        lineHeight: 1.3,
                    } }, product.name),
                React.createElement("div", { style: {
                        fontSize: typography.fontSizeXs,
                        color: colors.textSecondary,
                        fontFamily: typography.fontFamily,
                        marginTop: 2,
                    } }, product.tagline))),
        React.createElement("div", { style: {
                width: '100%',
                height: 140,
                borderRadius: radius.card,
                backgroundColor: colors.lightBg,
                border: `1px dashed ${colors.border}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: typography.fontSizeXs,
                color: colors.textMuted,
                fontFamily: typography.fontFamily,
                overflow: 'hidden',
            } },
            React.createElement("img", { src: product.screenshotPlaceholder, alt: `${product.name} screenshot`, style: { width: '100%', height: '100%', objectFit: 'cover' }, onError: (e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                        target.parentElement.textContent = 'Screenshot coming soon';
                    }
                } })),
        React.createElement("p", { style: {
                margin: 0,
                fontSize: typography.fontSizeSm,
                color: colors.textSecondary,
                fontFamily: typography.fontFamily,
                lineHeight: 1.6,
            } }, product.description),
        React.createElement("ul", { style: {
                margin: 0,
                padding: 0,
                listStyle: 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: spacing.xs,
                flexGrow: 1,
            } }, product.features.map((feature) => (React.createElement("li", { key: feature, style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: spacing.xs,
                fontSize: typography.fontSizeXs,
                fontFamily: typography.fontFamily,
                color: colors.textSecondary,
                lineHeight: 1.5,
            } },
            React.createElement("span", { style: { color: colors.success, fontWeight: 700, flexShrink: 0 } }, "\u2713"),
            feature)))),
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                marginTop: 'auto',
                gap: spacing.xs,
            } },
            React.createElement("div", { style: { display: 'flex', gap: spacing.xs } },
                React.createElement("a", { href: `/extensions/${product.id}`, style: {
                        display: 'inline-block',
                        padding: `${spacing.xs}px ${spacing.sm}px`,
                        border: `1px solid ${colors.primary}`,
                        color: colors.primary,
                        textDecoration: 'none',
                        borderRadius: radius.button,
                        fontSize: typography.fontSizeXs,
                        fontFamily: typography.fontFamily,
                        fontWeight: 600,
                    } }, "Details"),
                React.createElement("a", { href: product.marketplaceUrl, target: "_blank", rel: "noopener noreferrer", style: {
                        display: 'inline-block',
                        padding: `${spacing.xs}px ${spacing.md}px`,
                        backgroundColor: colors.primary,
                        color: colors.white,
                        textDecoration: 'none',
                        borderRadius: radius.button,
                        fontSize: typography.fontSizeXs,
                        fontFamily: typography.fontFamily,
                        fontWeight: 600,
                    } }, "Try Free \u2192")))));
};
